import styled from 'styled-components'
import Background from '../images/background_pattern.png'

export default styled.div`
  ${'' /* background-color: black;
  background-image: url(${Background}); */}
  padding-bottom: 109.5px;
  overflow: hidden;

  strong, b {
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
    font-weight: normal;
  }

  .check-in-msg {
    position: absolute;
    top: 50%;
    margin: 20px;
    transform: translateY(-50%);
    text-align: center;
  }

  .dropdown_menu {
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    font-size: 14px;
    color: white;
    text-transform: uppercase;

    position: absolute;
    top: 14px;
    right: 16px;
    padding: 2px;

    background-color: black;

    &_label {
      position: relative;

      padding-top: 5px;
      padding-bottom: 5px;
      padding-left: 13px;
      margin-top: 5px;
      cursor: pointer;

      &:before {
        content: '▾';
        /* Hide Text */
        text-indent: 20000%;
        overflow: hidden;
        white-space: nowrap;
        /* draw triangle */
        border-style: inset;
        transform: rotate(-90deg);
        width: 0;
        height: 0;
        border: transparent solid 0;
        border-top-width: 4px;
        border-right-width: 4px;
        border-left-width: 4px;
        border-top-color: currentColor;
        /* position */
        position: absolute;
        top: calc(50% - 2px);
        left: 0;
        /* transition */
        transition: transform 0.2s;
      }
    }

    &_list {
      display: none;
      list-style: none;
      padding-left: 13px;
      /* min-width: 180px; */

      position: absolute;

      li a {
        display: block;
        padding: 5px 0 5px 13px;
        margin-left: -13px;
      }

    }
  }
  .dropdown_menu_toggle:checked ~ .dropdown_menu_list {
    display: block;
  }
  .dropdown_menu_toggle:checked ~ .dropdown_menu_label:before {
    transform: rotate(0deg);
  }

  .chanel-logo, .coco-logo {
    margin: 0 auto;
    display: block;
  }

  .chanel-logo {
    padding-top: 55px;
    width: 180px;
  }

  .coco-logo {
    padding-top: 40px;
    width: 240px;
    object-fit: contain;
  }

  .qrcode-container {
    width: 200px;
    margin: 52px auto 0;
  }

  .qrcode {
    background-color: #000000;
    padding: 16px;
  }

  .qrcode-text-container {
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    font-size: 9px;
    color: #ffffff;
    width: 95vw;
    margin: 31px auto 72px;
    text-align: center;
    [lang="tw"] {
      font-size: 12px;
    }
  }

  .reservation-details-container {
    padding: 22px 5px;
    width: 91.8vw;
    max-width: 640px;
    background-color: rgba(0, 0, 0, 0);
    margin: 0 auto;

    .your-reservation-title {
      font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
      font-size: 18px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: -0.4px;
      text-align: center;
      color: #ffffff;
    }

    .reservation-details, .reservation-time, .address {
      font-family: 'ABChanel PB Regular S', Arial, sans-serif;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.75em;
      letter-spacing: -0.3px;
      text-align: left;
      color: #ffffff;
    }

    .reservation-details {
      margin-top: 49px;
      margin-bottom: 20px;
    }

    .reservation-time {
      padding: 20px 0;

      position: relative;

      &:after {
        content: '-';
        /* Hide Text */
        text-indent: 20000%;
        overflow: hidden;
        white-space: nowrap;

        position: absolute;
        top: 100%;
        left: -5px;
        right: -5px;

        height: 1px;
        background-color: white;
        pointer-events: none;
      }
      /* border-bottom: solid 1px #ffffff; */

      .reservation-title {
        font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
        font-weight: normal;
      }
    }

    .guest-container {
      margin-top: 14px;
      border-top: dashed 1px rgba(255, 255, 255, 0.5);
      :not(:last-child) {
        padding: 11px 0;
      }
      .guest-detail {
        padding-top: 11px;
      }
    }

    .address {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }

  .change-reservation-container {
    margin: auto;
    width: 91.8vw;
    max-width: 640px;

    .change-reservation-text {
      width: 100%;
      margin: 52px auto 26px;
      font-family: 'ABChanel PB Regular S', Arial, sans-serif;
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: -0.3px;
      text-align: center;
      color: #ffffff;
      &[lang="tw"] {
        font-size: 14px;
      }
    }
    .change-reservation-btn {
      width: 100%;
      height: 50px;
      margin: 0 auto;
      display: block;
      background-color: #000000;
      border: solid 1px #ffffff !important;
      font-family: 'ABChanel PB Regular S', Arial, sans-serif;
      font-size: 12px;
      color: #ffffff;
      &[lang="tw"] {
        font-size: 14px;
      }

      @media only screen and (min-width: 480px) {
        max-width: 320px;
      }
    }
  }

  .start-btn-container {
    background-color: black;
    background-image: url(${Background});
    position: fixed;
    width: 100vw;
    height: 69px;
    margin: auto;
    bottom: 0;
  }

  .start-btn {
    background-color: #ffffff;
    width: 95vw;
    height: 50px;
    margin: 9.5px auto;
    display: block;
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    font-size: 12px;
    letter-spacing: -0.3px;
    text-align: center;
    color: #000000;
    appearance: none;
    border: none;

    html[lang=tw] & {
      font-size: 14px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/styles/Home.js